import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { WEBSOCKET_HOSTNAME } from '../../../constants/constants';
import { TWebsocketHostname } from '../../../interface/interfaces';

interface IInitialState {
    hostnameAndUsername: TWebsocketHostname | null
}

const storedHostname = localStorage.getItem(WEBSOCKET_HOSTNAME);

let initialProject: TWebsocketHostname | null = null;
try {
    initialProject = storedHostname ? JSON.parse(storedHostname) : null;
} catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error parsing hostname and username from localStorage:', error);
    initialProject = null;
}

const initialState: IInitialState = {
    hostnameAndUsername: initialProject,
};

const websocketHostnameSlice = createSlice({
    name: 'websocketHostname',
    initialState,
    reducers: {
        saveHostnameAndUsername: (state: IInitialState, action: PayloadAction<TWebsocketHostname>) => {
            state.hostnameAndUsername = action.payload;
            localStorage.setItem(WEBSOCKET_HOSTNAME, JSON.stringify(action.payload));
        },

        removeHostnameAndUsername: (state: IInitialState) => {
            state.hostnameAndUsername = null;
            localStorage.removeItem(WEBSOCKET_HOSTNAME);
        },
    },
});

export default websocketHostnameSlice.reducer;
export const { saveHostnameAndUsername, removeHostnameAndUsername } = websocketHostnameSlice.actions;
